import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { SensorScene } from 'scenes';

class SensorContainer extends AbstractContainer {

  getTasks(params) {

    let sensor = params.sensor;

    return [
      {
        key: 'sensor',
        exec: (done, failure) => {
          API.get(`sensors/${sensor}`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <SensorScene sensor={results.sensor} />
  }
}

export default SensorContainer;
